module.exports = __webpack_public_path__ + "images/emoji/minidisc.c719877217d032cb0e56.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/minidisc.png
// module id = fAdQ
// module chunks = 24